(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-product-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haubon-photo-reviews')) {
  customElements.define('haubon-photo-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.feedObserver?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.rail = this.querySelector('[data-photo-rail]');
      this.cards = [...this.querySelectorAll('[data-photo-card]')].filter(card => !card.hidden);
      this.previous = this.querySelector('[data-photo-step="-1"]');
      this.next = this.querySelector('[data-photo-step="1"]');
      this.position = this.querySelector('[data-photo-position]');
      this.dialog = this.querySelector('[data-photo-dialog]');
      if (!this.rail) return;
      this.feedLoading = false;
      this.querySelector('[data-photo-navigation]').hidden = false;
      this.rail.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.addEventListener('click', event => {
        const step = event.target.closest('[data-photo-step]');
        if (step) this.move(Number(step.dataset.photoStep));
        const trigger = event.target.closest('[data-review-open]');
        if (trigger) {
          this.opener = trigger;
          const content = trigger.closest('[data-photo-card]').querySelector('template').content.cloneNode(true);
          this.querySelector('[data-photo-detail]').replaceChildren(content);
          this.dialog.showModal();
          this.querySelector('[data-photo-close]').focus();
        }
        if (event.target.closest('[data-photo-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }, options);
      this.rail.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.scroll(event.key === 'Home' ? 0 : this.rail.scrollWidth);
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.dialog.addEventListener('close', () => {
        this.querySelector('[data-photo-detail]').replaceChildren();
        this.opener?.focus({ preventScroll: true });
      }, options);
      this.cards.forEach(card => this.watchPhoto(card));
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.rail);
      this.update();
      this.feedObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.feedObserver.disconnect();
          this.loadStoreReviews();
        }
      }, { rootMargin: '700px' });
      this.feedObserver.observe(this.closest('.pdp-reviews'));
      this.addEventListener('focusin', () => this.loadStoreReviews(), options);
    }
    watchPhoto(card) {
      const image = card.querySelector('.photo-reviews__image');
      const discardBrokenPhoto = () => {
        card.hidden = true;
        this.cards = this.cards.filter(item => item !== card);
        this.hidden = this.cards.length === 0;
        this.update();
      };
      image.addEventListener('error', discardBrokenPhoto, { signal: this.controller.signal });
      if (image.complete && image.currentSrc && !image.naturalWidth) discardBrokenPhoto();
    }
    async loadStoreReviews() {
      if (this.feedLoaded || this.feedLoading) return;
      this.feedLoading = true;
      const signal = this.controller.signal;
      const seen = new Set([...this.rail.querySelectorAll('[data-review-id]')].map(card => card.dataset.reviewId));
      const visited = new Set();
      const additional = [];
      let next = new URL(this.dataset.feedUrl, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) next.searchParams.set('preview_theme_id', preview);
      try {
        while (next && !visited.has(next.href)) {
          if (next.origin !== location.origin) throw new Error('Invalid photo review feed');
          visited.add(next.href);
          const response = await fetch(next.href, { signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Photo reviews unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const feed = doc.querySelector('[data-photo-feed]');
          if (!feed) throw new Error('Photo review feed missing');
          feed.querySelectorAll('[data-photo-card]').forEach(card => {
            if (card.dataset.productId === this.dataset.productId || seen.has(card.dataset.reviewId)) return;
            seen.add(card.dataset.reviewId);
            additional.push(card);
          });
          const following = feed.dataset.nextPage;
          if (following) {
            next = new URL(following, next);
            next.searchParams.set('section_id', 'ch-photo-review-feed');
            next.searchParams.set('sort_by', 'title-ascending');
            if (preview) next.searchParams.set('preview_theme_id', preview);
          } else next = null;
        }
        if (signal.aborted) return;
        additional.sort((a, b) => Number(b.dataset.createdAt) - Number(a.dataset.createdAt));
        this.rail.append(...additional);
        this.cards.push(...additional);
        this.hidden = this.cards.length === 0;
        additional.forEach(card => this.watchPhoto(card));
        this.feedLoaded = true;
        this.querySelector('[data-photo-intro]').hidden = !additional.length;
        const fullReviews = this.closest('.pdp-reviews').querySelector('.pdp-reviews__all');
        if (fullReviews) {
          fullReviews.classList.toggle('pdp-reviews__all--with-photos', this.cards.length > 0);
          fullReviews.querySelector('[data-product-review-heading]').hidden = !additional.length;
        }
        this.update();
      } catch (error) {
        if (!signal.aborted) {
          this.addEventListener('pointerdown', () => this.loadStoreReviews(), { once: true, signal });
        }
      } finally {
        if (!signal.aborted) this.feedLoading = false;
      }
    }
    scroll(left) {
      this.rail.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    move(direction) {
      const railLeft = this.rail.getBoundingClientRect().left;
      const targets = this.cards.map(card => card.getBoundingClientRect().left - railLeft + this.rail.scrollLeft);
      const current = this.rail.scrollLeft;
      const target = direction > 0 ? targets.find(left => left > current + 2) : targets.reverse().find(left => left < current - 2);
      this.scroll(target ?? (direction > 0 ? this.rail.scrollWidth : 0));
    }
    update() {
      const left = this.rail.scrollLeft;
      const end = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      this.previous.disabled = left <= 2;
      this.next.disabled = left >= end - 2;
      this.querySelector('[data-photo-navigation]').hidden = end <= 2;
      const bounds = this.rail.getBoundingClientRect();
      const visible = this.cards.map((card, index) => ({ rect: card.getBoundingClientRect(), index })).filter(({ rect }) => rect.left < bounds.right - 2 && rect.right > bounds.left + 2);
      if (visible.length) {
        const first = visible[0].index + 1;
        const last = visible[visible.length - 1].index + 1;
        this.position.textContent = `${first === last ? first : `${first}–${last}`} / ${this.cards.length}`;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.feedObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
